var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',{staticClass:"text-body-1 pb-1 text-truncate d-block"},[_vm._v("\n    "+_vm._s(_vm.achievementTypeName)+"\n  ")]),_vm._v(" "),_c('v-card-title',{staticClass:"pt-1 font-weight-bold text-truncate d-block"},[_vm._v("\n    "+_vm._s(_vm.achievementName)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }